export default function clone<T>(object: T): T {
  if (!object) return {} as T;
  return JSON.parse(JSON.stringify(object));
  // return structuredClone(object); // change when update to angular 14 and typescript 4.7
}
